import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../components/Layout";
import PrivateRoute from "../components/PrivateRoute";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import MyClassrooms from "../pages/Classrooms/MyClassrooms";
import Exams from "../pages/Student/exams/[slug]";
import ExamsDetails from "../pages/Student/exams/examDetails";
import StudentDashboard from "../pages/StudentDashboard";
import ConceptVideosList from "../pages/StudentPages/ConceptVideos/ConceptVideosList";
import Performance from "../pages/Student/Performance";
import StudentPractice from "../pages/StudentPages/Practice/Practice";
import FullLengthExams from "../pages/StudentPages/FullLengthExams";
import TopicwiseTest from "../pages/StudentPages/TopicwiseTest/TopicwiseTestList";
import PaymentForm from "../pages/Student/PaymentForm";
import PaymentSuccessful from "../pages/Student/PaymentForm/PaymentSuccessful";
import PaymentFailure from "../pages/Student/PaymentForm/PaymentFailure";
import PaymentCallback from "../pages/Student/PaymentForm/PaymentCallback";
import LiveClasses from "../pages/Classrooms/Create/LiveClasses";
import WrongQuestionsPage from "../components/StudentDashboard/WroongQuestionsReport/WrongQuestionPage";

// import AlfalahTestStandalone from "../pages/AlfalahTestPage/AlfalahTestStandalone";
// import Pricing from "../pages/Student/Pricing";
// import Recordings from "../pages/StudentPages/Recordings/Recordings";
// import WhatsNewPage from "../pages/StudentPages/WhatsNew";
// import TopicCompletionDetails from "../components/PerformanceComponents/TopicCompletionDetails";
// IELTS Exams (New separate system)
// import Files from "../pages/StudentPages/Files";
// import LectureNotes from "../pages/StudentPages/LectureNotes/LectureNotes";
// import ModuleSelection from "../pages/StudentPages/IELTSExams/attempt/ModuleSelection";
// import FullExamAttempt from "../pages/StudentPages/IELTSExams/attempt/FullExamAttempt";
// import FullExamResults from "../pages/StudentPages/IELTSExams/attempt/FullExamResults";
// import ListeningInitialization from "../pages/StudentPages/IELTSExams/attempt/listening/ListeningInitialization";
// import ListeningAttempt from "../pages/StudentPages/IELTSExams/attempt/listening/ListeningAttempt";
// import ListeningResults from "../pages/StudentPages/IELTSExams/attempt/listening/ListeningResults";
// import ReadingAttempt from "../pages/StudentPages/IELTSExams/attempt/reading/ReadingAttempt";
// import ReadingResults from "../pages/StudentPages/IELTSExams/attempt/reading/ReadingResults";
// import WritingAttempt from "../pages/StudentPages/IELTSExams/attempt/writing/WritingAttempt";
// import WritingResults from "../pages/StudentPages/IELTSExams/attempt/writing/WritingResults";
// import SpeakingAttempt from "../pages/StudentPages/IELTSExams/attempt/speaking/SpeakingAttempt";
// import SpeakingResults from "../pages/StudentPages/IELTSExams/attempt/speaking/SpeakingResults";

const AlfalahTestStandalone = lazy(
  () => import("../pages/AlfalahTestPage/AlfalahTestStandalone"),
);
const Pricing = lazy(() => import("../pages/Student/Pricing"));
const Recordings = lazy(
  () => import("../pages/StudentPages/Recordings/Recordings"),
);
const WhatsNewPage = lazy(() => import("../pages/StudentPages/WhatsNew"));
const TopicCompletionDetails = lazy(
  () => import("../components/PerformanceComponents/TopicCompletionDetails"),
);

const IELTSExamDetails = lazy(
  () => import("../pages/StudentPages/IELTSExams/IELTSExamDetails"),
);
const ModuleSelection = lazy(
  () => import("../pages/StudentPages/IELTSExams/attempt/ModuleSelection"),
);
const FullExamAttempt = lazy(
  () => import("../pages/StudentPages/IELTSExams/attempt/FullExamAttempt"),
);
const FullExamResults = lazy(
  () => import("../pages/StudentPages/IELTSExams/attempt/FullExamResults"),
);
const ListeningInitialization = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/listening/ListeningInitialization"),
);
const ListeningAttempt = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/listening/ListeningAttempt"),
);
const ListeningResults = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/listening/ListeningResults"),
);
const ReadingAttempt = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/reading/ReadingAttempt"),
);
const ReadingResults = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/reading/ReadingResults"),
);
const WritingAttempt = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/writing/WritingAttempt"),
);
const WritingResults = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/writing/WritingResults"),
);
const SpeakingAttempt = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/speaking/SpeakingAttempt"),
);
const SpeakingResults = lazy(
  () =>
    import("../pages/StudentPages/IELTSExams/attempt/speaking/SpeakingResults"),
);
const LectureNotes = lazy(
  () => import("../pages/StudentPages/LectureNotes/LectureNotes"),
);
const AllNotificationsPage = lazy(
  () => import("../pages/NotificationsPage/NotificationsPage"),
);
const Files = lazy(() => import("../pages/StudentPages/Files"));
const DisplayFiles = lazy(
  () => import("../pages/StudentPages/Files/DisplayFiles"),
);
const DiscussionChannels = lazy(
  () =>
    import("../pages/AdminOrTeacherPages/Discussions/Channel/DiscussionChannels"),
);
const DiscussionChannelDetails = lazy(
  () =>
    import("../pages/AdminOrTeacherPages/Discussions/ChannelDetails/ChannelDetails"),
);
const AnnouncementDetails = lazy(
  () =>
    import("../pages/AdminOrTeacherPages/Announcements/AnnouncementDetails"),
);
const EventsCalender = lazy(
  () => import("../pages/AdminOrTeacherPages/EventsCalendar"),
);
const Profile = lazy(() => import("../pages/StudentPages/Profile"));

const AttemptResults = lazy(
  () => import("../pages/StudentPages/Practice/AttemptResults"),
);
const DisplayLectureNotes = lazy(
  () => import("../pages/StudentPages/LectureNotes/DisplayLectureNotes"),
);
const WatchConceptVideos = lazy(
  () => import("../pages/StudentPages/ConceptVideos/WatchConceptVideos"),
);
const ResultPage = lazy(() => import("../pages/Student/exams/ResultPage"));
const FullScreenRecoridng = lazy(
  () => import("../pages/StudentPages/Recordings/FullScreenRecording"),
);
const PracticeAttempt = lazy(
  () => import("../pages/StudentPages/Practice/Attempt"),
);
const ViewAllAttempts = lazy(
  () => import("../pages/StudentPages/Practice/ViewAllAttempts"),
);
const TestAttempt = lazy(
  () => import("../pages/StudentPages/TopicwiseTest/TestAttempt"),
);
const WritingPracticeAttempt = lazy(
  () => import("../pages/StudentPages/Practice/WritingPracticeAttempt"),
);
const WritingTestAttempt = lazy(
  () => import("../pages/StudentPages/TopicwiseTest/WritingTestAttempt"),
);
const SpeakingPracticeAttempt = lazy(
  () => import("../pages/StudentPages/Practice/SpeakingPracticeAttempt"),
);
const SpeakingTestAttempt = lazy(
  () => import("../pages/StudentPages/TopicwiseTest/SpeakingTestAttempt"),
);

const StudentRoutes = () => {
  return (
    <Routes>
      <Route
        path="/notifications/list"
        element={
          <Layout>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={AllNotificationsPage} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms"
        element={
          <Layout>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={MyClassrooms} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/dashboard"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={StudentDashboard} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/dashboard/wrong-questions"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={WrongQuestionsPage} />
          </Layout>
        }
      />
      <Route
        path="/student/profile"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={Profile} />
          </Layout>
        }
      />
      <Route
        path="/student/whats-new"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={WhatsNewPage} />
          </Layout>
        }
      />
      <Route
        path="/generalSettings"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={Profile} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/liveclasses"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={LiveClasses} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/discussions"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={DiscussionChannels} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/announcements"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={AnnouncementDetails} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/discussions/:channelId"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={DiscussionChannelDetails} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/recordings"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={Recordings} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:liveClass/:meetingId/play-recordings"
        element={<PrivateRoute Component={FullScreenRecoridng} />}
      />
      <Route
        path="/student/myClassrooms/:id/conceptvideos"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={ConceptVideosList} />
          </Layout>
        }
      />
      <Route
        path="/student/:id"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={Performance} />
          </Layout>
        }
      />
      <Route
        path="/student/:id/watchvideos/:subjectId"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={WatchConceptVideos} />
          </Layout>
        }
      />
      <Route
        path="/student/:id/:tabId"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={Performance} />
          </Layout>
        }
      />
      <Route
        path="/student/:id/topic-completion-details"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={TopicCompletionDetails} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/lecturenotes"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={LectureNotes} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/displayNotes"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={DisplayLectureNotes} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/practice"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={StudentPractice} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/tests"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={TopicwiseTest} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/calendar"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={EventsCalender} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/files"
        element={
          <DndProvider backend={HTML5Backend}>
            <Layout isSecondSidebarOpen={false}>
              {/* <ClassroomPage /> */}
              <PrivateRoute Component={Files} />
            </Layout>
          </DndProvider>
        }
      />
      <Route
        path="/student/myClassrooms/:id/files/displayFiles"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={DisplayFiles} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/files/folders/:folderId"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={Files} />
          </Layout>
        }
      />

      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/practice/writingAttempt/:practiceId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={WritingPracticeAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/practice/speakingAttempt/:practiceId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={SpeakingPracticeAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/practice/:practiceAttempt/:practiceId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={PracticeAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:attemptText/all-attempts/"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={ViewAllAttempts} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/attempt-results/:practiceId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={AttemptResults} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/test/writingTestAttempt/:testId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={WritingTestAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/test/speakingTestAttempt/:testId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={SpeakingTestAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/:subjectId/:topicId/test/:testAttempt/:testId/"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={TestAttempt} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/full-length-exams"
        element={
          <Layout isSecondSidebarOpen={false}>
            {/* <ClassroomPage /> */}
            <PrivateRoute Component={FullLengthExams} />
          </Layout>
        }
      />
      <Route
        path="/student/:classroomId/exams/:examId/details"
        element={
          <DndProvider backend={HTML5Backend}>
            <PrivateRoute Component={ExamsDetails} />
          </DndProvider>
        }
      />
      <Route
        path="/student/:classroomId/exams/:id"
        element={
          <DndProvider backend={HTML5Backend}>
            <PrivateRoute Component={Exams} />
          </DndProvider>
        }
      />

      <Route
        path="/student/:classroomId/exams/:id/result"
        element={
          <DndProvider backend={HTML5Backend}>
            <PrivateRoute Component={ResultPage} />
          </DndProvider>
        }
      />
      <Route
        path="/student/myClassrooms/:id/pricing"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={Pricing} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/payment-form"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={PaymentForm} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/payment-success"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={PaymentSuccessful} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/payment-failure"
        element={
          <Layout isSecondSidebarOpen={false}>
            <PrivateRoute Component={PaymentFailure} />
          </Layout>
        }
      />
      <Route
        path="/student/myClassrooms/:id/alfalah-test"
        element={<PrivateRoute Component={AlfalahTestStandalone} />}
      />

      {/* Generic Payment Callback - Static URL for Bank Alfalah */}
      <Route
        path="/payment-callback"
        element={<PrivateRoute Component={PaymentCallback} />}
      />

      {/* IELTS Exams Routes - New Separate System (Without Sidebar Layout) */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId"
        element={<PrivateRoute Component={IELTSExamDetails} />}
      />

      {/* IELTS Module Selection */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/modules"
        element={<PrivateRoute Component={ModuleSelection} />}
      />

      {/* IELTS Full Exam Attempt */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/full"
        element={<PrivateRoute Component={FullExamAttempt} />}
      />

      {/* IELTS Listening - Initialization (Pre-test setup) */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/listening/init"
        element={<PrivateRoute Component={ListeningInitialization} />}
      />

      {/* IELTS Listening Attempt */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/listening"
        element={<PrivateRoute Component={ListeningAttempt} />}
      />

      {/* IELTS Listening Results */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/listening/results"
        element={<PrivateRoute Component={ListeningResults} />}
      />

      {/* IELTS Full Exam Results */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/results"
        element={<PrivateRoute Component={FullExamResults} />}
      />

      {/* IELTS Reading Attempt */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/reading"
        element={<PrivateRoute Component={ReadingAttempt} />}
      />

      {/* IELTS Reading Results */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/reading/results"
        element={<PrivateRoute Component={ReadingResults} />}
      />

      {/* IELTS Writing Attempt */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/writing"
        element={<PrivateRoute Component={WritingAttempt} />}
      />

      {/* IELTS Writing Results */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/writing/results"
        element={<PrivateRoute Component={WritingResults} />}
      />

      {/* IELTS Speaking Attempt */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/speaking"
        element={<PrivateRoute Component={SpeakingAttempt} />}
      />

      {/* IELTS Speaking Results */}
      <Route
        path="/student/myClassrooms/:classroomId/ielts-exams/:examId/attempt/speaking/results"
        element={<PrivateRoute Component={SpeakingResults} />}
      />
    </Routes>
  );
};

export default StudentRoutes;
